// General
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';

// Translation
import { FormattedMessage } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './HeaderModal.css';
import {
  Modal
} from 'react-bootstrap';

// Components
import LanguageModal from '../LanguageModal';

// Action
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';

// Helper
import messages from '../../locale/messages';


class HeaderModal extends Component {

  static defaultProps = {
    modalType: 'languageModal'
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { closeHeaderModal, modalStatus, modalType } = this.props;

    return (
      <div>
        <Modal
          show={modalStatus}
          animation={false}
          onHide={() => closeHeaderModal(modalType)}
          dialogClassName={cx(s.logInModalContainer, 'wooberlyModal', 'wooberlyModalWidth', 'languageModal')}
        >
          <Modal.Header closeButton>
            <Modal.Title className={s.textAlignCenter}>
              <h2 className={s.headerH2}><FormattedMessage {...messages.chooseLanguageLabel} /></h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body bsClass={s.logInModalBody}>
            <div>
              {
                <LanguageModal />
              }
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapState = state => ({
  modalStatus: state.modalStatus.languageModal
});

const mapDispatch = {
  closeHeaderModal
};

export default withStyles(s)(connect(mapState, mapDispatch)(HeaderModal));